import { FC, useCallback } from 'react'
import { useStoreSelector, useStoreDispatch } from 'helpers/reactReduxHelpers'
import FloatingPaneNotification from 'components/features/pfm/FloatingPaneNotification/FloatingPaneNotification'
import { ResetCancelMeetingAction, ResetCreateMeetingAction } from 'components/features/coaching/advisorStore/actions/advisorMeetingActions'
import { getRequestErrors } from 'helpers/errorHelpers'

type MeetingPaneErrorProps = {
}
export const MeetingPaneError: FC<MeetingPaneErrorProps> = () => {

  const createMeetingErrorMessage = useStoreSelector((state) => {
    const { createMeetingRequest } = state.data.advisors
    return getRequestErrors(createMeetingRequest)
  })

  const cancelMeetingErrorMessage = useStoreSelector((state) => {
    const { cancelMeetingRequest } = state.data.advisors
    return getRequestErrors(cancelMeetingRequest)
  })

  const errorMessages = createMeetingErrorMessage || cancelMeetingErrorMessage

  const dispatch = useStoreDispatch()
  const handleClose = useCallback(() => {
    dispatch(new ResetCancelMeetingAction())
    dispatch(new ResetCreateMeetingAction())
  }, [dispatch])

  if (errorMessages === null || errorMessages.length < 1) {
    return null
  }

  return (
    <FloatingPaneNotification onDismiss={ handleClose } messages={ errorMessages } />
  )
}
